import Box from "@mui/material/Box";
import React, {FC} from "react";
import {Modal, Typography} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {Close} from "@mui/icons-material";
import {
	CompletionCelebrationContent
} from "@/pages/CoursePage/CourseCompletionCelebration/CompletionCelebrationContent";
import Lottie from "react-lottie";
import * as animationData from "../../../icons/lottie/celebration.json";
import {useSSTranslation} from "@/i18n/useSSTranslation";

interface IProps {
	open: boolean;
	onClose: (needsToContinue?: boolean) => void;
}

const useStyles = makeStyles()(() => ({
	modalWrapper: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		outline: "none"
	},
	modalBox: {
		backgroundColor: "#181818",
		borderRadius: "12px",
		width: 600,
		maxWidth: "calc(100% - 40px)",
		padding: "20px",
		position: "relative",
		overflow: "hidden",
		color: "#fff"
	},
	closeIcon: {
		position: "absolute",
		top: 12,
		right: 12,
		color: "#F9F9F98F",
		cursor: "pointer",
		zIndex: 2
	},
	content: {
		position: "relative",
		zIndex: 1,
		textAlign: "center"
	},
	animationBackground: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		zIndex: 0,
		pointerEvents: "none"
	}
}));

export const CompletionCelebrationContentModal: FC<IProps> = ({open, onClose}) => {
	const {t} = useSSTranslation();
	const {classes} = useStyles();

	const defaultOptions = {
		loop: false,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice"
		}
	};

	return (
		<Modal open={open} onClose={() => onClose?.()}>
			<Box className={classes.modalWrapper}>
				<Box className={classes.modalBox}>
					<Box className={classes.animationBackground}>
						<Lottie options={defaultOptions} height={400} width={400} />
					</Box>
					<Close className={classes.closeIcon} onClick={() => onClose?.()} />
					<Typography variant="h5" gutterBottom>
						{t("completion_celebration_you_did_it", "You did it!")}
					</Typography>
					<Box className={classes.content}>
						<CompletionCelebrationContent onContinue={() => onClose?.(true)}/>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};
